import { useContent } from '@/stores/RootStore';
import { observer } from 'mobx-react-lite';
import s from './TalentValues.module.scss';

// 인재상 2대 가치 — evstech 아이콘(png)을 EVS 라인 SVG로 재해석(2026-08-02).
//   창의(CREATIVITY)=전구(아이디어), 신의(TRUST)=방패+체크(신뢰·책임).
const ICONS: Record<string, JSX.Element> = {
  creativity: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 18h6" /><path d="M10 21h4" />
      <path d="M12 2a6.5 6.5 0 0 1 4 11.6c-.7.6-1 1.2-1 2.4H9c0-1.2-.3-1.8-1-2.4A6.5 6.5 0 0 1 12 2z" />
      <path d="M12 6.5v3M10.6 8h2.8" />
    </svg>
  ),
  trust: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2.5l7 3v5.2c0 4.6-3.1 7.8-7 9.3-3.9-1.5-7-4.7-7-9.3V5.5l7-3z" />
      <path d="M8.7 12l2.3 2.3L15.4 10" />
    </svg>
  ),
};

const TalentValues = observer(() => {
  const { talent } = useContent();
  return (
    <div className={s.grid}>
      {talent.values.map((v) => (
        <article key={v.en} className={s.card}>
          <span className={s.icon}>{ICONS[v.icon]}</span>
          <p className={s.en}>{v.en}</p>
          <h3 className={s.ko}>
            {v.ko}<span className={s.hanja}>{v.hanja}</span>
          </h3>
          <ul className={s.keywords}>
            {v.keywords.map((k) => <li key={k}>{k}</li>)}
          </ul>
          <p className={s.desc}>{v.desc}</p>
        </article>
      ))}
    </div>
  );
});

export default TalentValues;
